import React from 'react'
import { Grid, Typography } from '@mui/material'
import { WorkOrderInBoundLocate } from '../../../../interfaces/WorkOrder/WorkOrder'

interface DetailsDocsMatchPutAwayProps {
  workOrderInboundLocate: WorkOrderInBoundLocate
}

export const DetailsDocsMatchPutAway = ({
  workOrderInboundLocate
}: DetailsDocsMatchPutAwayProps) => {
  return (
    <Grid container xs={12} spacing={1}>
      <Grid item xs={12}>
        <Typography variant='body2' component='p'>
          <b>Proveedor: </b>
          {workOrderInboundLocate.supplierName}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body2' component='p'>
          <b>Origen: </b>
          {workOrderInboundLocate.supplierOriginName}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body2' component='p'>
          <b>Unidades Totales: </b> {workOrderInboundLocate.unitsQty}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body2' component='p'>
          <b>Marca: </b> {workOrderInboundLocate.brandName}
        </Typography>
      </Grid>
    </Grid>
  )
}
